import { CreateFlagSection } from "./CreateFlagSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

export function FeaturesScreen(): JSX.Element {
  return (
    <ScreenFrame screen="features">
      <SettingsSection screen="features" />
      <CreateFlagSection />
    </ScreenFrame>
  );
}
